// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2ZRw1","Image":"Button_Image__1d-w7","ImageAlt":"Button_ImageAlt__1u0pa"};